// extracted by mini-css-extract-plugin
export default {"wrapper":"Dn-z","response":"En-z","error":"Fn-z","disabled":"Gn-z","buttons":"Hn-z","feedbackQuestionSection":"In-z","yesNoWrapper":"Jn-z"};